import DeliveryManagmentTable from 'components/delivery-managment-table';
import React from 'react';

const DeliveryManagment = () => {
  return (
    <div>
      <DeliveryManagmentTable />
    </div>
  );
};

export default DeliveryManagment;
